import { useSilentAwaken } from '~/utils/active/use-silent-awaken';
import { useAtomValue } from 'jotai';
import { FC, useEffect, useMemo } from 'react';
import { DeepLinkBuildingProps } from '~/utils/active/schema';
import { $CurrentUserAsAvailable, $CurrentUserOrNull } from '@user/shared/current-user';
import { $CurrentUserPost } from '@user/shared/current-user-post';
import { $CurrentUserRelatedUser } from '@user/shared/current-user-related-user';
import { loadable } from 'jotai/utils';
import { $DOMReadyState, $InstalledRelatedApp, $UserAgent } from '@lemon8/web-app-shared/atom';
import { buildDeepLink } from '~/utils/active';

export const UserSilentAwaken: FC = () => {
  const user = useAtomValue($CurrentUserAsAvailable);

  const loadableCurrentUserPost = useAtomValue(loadable($CurrentUserPost));
  const loadableCurrentUserRelatedUser = useAtomValue(loadable($CurrentUserRelatedUser));

  const schemaOption: DeepLinkBuildingProps = useMemo(() => {
    const { userId } = user;
    return { pid: 'sharing_install', pageType: 'user', userId };
  }, []);

  useSilentAwaken({
    awakenOptions: { schemaOption },
    hasFulfilled: loadableCurrentUserPost.state === 'hasData' && loadableCurrentUserRelatedUser.state === 'hasData',
  });

  return null;
};

export const UserSilentAwakenV2: FC = () => {
  const { userAgent } = useAtomValue($UserAgent);
  const domReadyState = useAtomValue($DOMReadyState);
  const installedRelatedApp = useAtomValue($InstalledRelatedApp);
  const user = useAtomValue($CurrentUserOrNull);

  useEffect(() => {
    if (domReadyState === 'complete' && /android/i.test(userAgent)) {
      try {
        let schemaOption: DeepLinkBuildingProps;
        if (!user) {
          schemaOption = { pid: 'sharing_install', pageType: 'feed', categoryId: 0 };
        } else {
          schemaOption = {
            pid: 'sharing_install',
            pageType: 'user',
            userId: user.userId,
          };
        }

        location.href = buildDeepLink({ schemaOption });
      } catch (e) {
        console.error('error in silent awaken', e);
      }
    }
  }, [domReadyState, userAgent]);

  useEffect(() => {
    if (installedRelatedApp && installedRelatedApp !== 'pending') {
      window.Tea('wap_with_app', {
        installed_app_name: installedRelatedApp.id,
        installed_app_version: installedRelatedApp.version,
      });
    }
  }, [installedRelatedApp]);

  return null;
};
